import { InputTasa, InputSubTasa, AccordionIcon, FormLabel, FormError } from '../../../components/common'
import { OPERATION_MODE } from '@laramie/ui';
const TasasPlan = ({ toggle, open, formValues, handleInputProxy, errorOf, params }) => {
    return <>
        <div className='accordion-header m-top-20'>
            <div className='row'>
                <div className="col-12" onClick={toggle}>
                    <div className='accordion-header-title'>
                        <AccordionIcon open={open} />
                        <h3 className={open ? 'active' : ''}>Tasas del plan de pago</h3>
                    </div>
                </div>
            </div>
        </div>
        {open && (
            <div className='accordion-body'>
                <div className='row form-basic'>

                    <div className="col-12 col-md-6 col-lg-3">
                        <FormLabel htmlFor="idTasaPagoContado" required>Tasa del plan de pago</FormLabel>
                        <InputTasa
                            name="idTasaPagoContado"
                            placeholder=""
                            className={`form-control ${errorOf('idTasaPagoContado') ? 'is-invalid' : ''}`}
                            value={formValues.idTasaPagoContado}
                            onChange={handleInputProxy}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                            hideLoading
                        />
                        <FormError message={errorOf('idTasaPagoContado')} />
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <FormLabel htmlFor="idSubTasaPagoContado" required>Sub tasa del plan de pago</FormLabel>
                        <InputSubTasa
                            name="idSubTasaPagoContado"
                            placeholder=""
                            className={`form-control ${errorOf('idSubTasaPagoContado') ? 'is-invalid' : ''}`}
                            value={formValues.idSubTasaPagoContado}
                            onChange={handleInputProxy}
                            idTasa={formValues.idTasaPagoContado}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                            hideLoading
                        />
                        <FormError message={errorOf('idSubTasaPagoContado')} />
                    </div>
                </div>
            </div>
        )}
    </>
}

export default TasasPlan
